import { parse } from "date-fns";

/**
 * Also known as `makeDateTime` in ctv-web-next repository
 */
export default function parseFlightApiDate(date: string, time: string) {
  return parse(`${date} ${time}`, "yyyy-MM-dd HH:mm", 0);
}
